"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRepetitionTypePicker = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const CustomRepetitionType_1 = __importDefault(require("@opsbase/lib-time/CustomRepetitionType"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const makePicker_1 = __importDefault(require("@opsbase/web-pickers/helpers/makePicker"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    lightText: {
        color: lib_palette_1.default.GreyBlue.main,
    },
});
exports.CustomRepetitionTypePicker = (0, makePicker_1.default)((props) => {
    return (react_1.default.createElement(Select_1.default, Object.assign({}, props),
        react_1.default.createElement(MenuItem_1.default, { value: CustomRepetitionType_1.default.WEEKLY },
            react_1.default.createElement(InnerBit, { title: "Weekly", description: "e.g. every Monday and Thursday" })),
        react_1.default.createElement(MenuItem_1.default, { value: CustomRepetitionType_1.default.MONTHLY },
            react_1.default.createElement(InnerBit, { title: "Monthly", description: "e.g. the 2nd Monday of every month" })),
        react_1.default.createElement(MenuItem_1.default, { value: CustomRepetitionType_1.default.MONTHLY_BY_DATE },
            react_1.default.createElement(InnerBit, { title: "Monthly (by Date)", description: "e.g. the 3rd of every month" })),
        react_1.default.createElement(MenuItem_1.default, { value: CustomRepetitionType_1.default.YEARLY },
            react_1.default.createElement(InnerBit, { title: "Yearly", description: "e.g. the 2nd Monday of April each year" })),
        react_1.default.createElement(MenuItem_1.default, { value: CustomRepetitionType_1.default.YEARLY_BY_DATE },
            react_1.default.createElement(InnerBit, { title: "Yearly (by Date)", description: "e.g. the 21st of April each year" }))));
});
exports.default = exports.CustomRepetitionTypePicker;
function InnerBit({ title, subTitle = '', description = '' }) {
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Text_1.default, null,
            title,
            " ",
            !!subTitle && react_1.default.createElement("span", { className: myCss.lightText }, subTitle)),
        !!description && react_1.default.createElement(Text_1.default, { className: myCss.lightText }, description)));
}
